document.addEventListener("DOMContentLoaded", function () {
  // Find the header - support both old header and header-v2
  const header = document.querySelector(".mm-header") || document.querySelector("header")
  const promoBanner = document.querySelector("#promo-banner-fixed, .promo-banner-fixed")

  // Note: Main content padding is now handled by CSS in promo-banner-fixed.liquid
  // This avoids layout shift and ensures consistent spacing

  // Only set padding for Skio account pages which have different layout
  let skioImageBanner = document.querySelector(".skio-banner-wrapper")
  if (window.location.href.includes("/a/account") && skioImageBanner) {
    const promoBannerHeight = promoBanner ? promoBanner.offsetHeight : 0
    const navBarHeight = header ? header.offsetHeight : 0
    skioImageBanner.style.paddingTop = (promoBannerHeight + navBarHeight) + "px"
  }

  // quantity incrementers
  document.querySelectorAll(".js-qty-wrap .plus").forEach((el) => {
    el.addEventListener("click", function () {
      const container = el.closest(".js-qty-wrap")
      const input = container.querySelector("input")
      let n = parseInt(input.value)
      input.value = ++n
      input.dispatchEvent(new Event("change"))
    })
  })
  document.querySelectorAll(".js-qty-wrap .min").forEach((el) => {
    el.addEventListener("click", function () {
      const container = el.closest(".js-qty-wrap")
      const input = container.querySelector("input")
      let n = parseInt(input.value)
      if (n >= 1) {
        input.value = --n
        input.dispatchEvent(new Event("change"))
      }
    })
  })
  document.querySelectorAll(".footer-nav-header").forEach((el) => {
    el.addEventListener("click", function () {
      if (window.innerWidth < 767) {
        el.parentElement.classList.toggle("expanded")
        el.classList.toggle("expanded")
      }
    })
  })

  /* Mobile Sticky Nav */
  let lastScrollTop = 0;
  let isScrolling;

  window.addEventListener("scroll", function () {
    if (window.innerWidth >= 768) return; // Only run on mobile screens

    const st = window.scrollY;
    const mobileNavBar = document.querySelector("#shopify-section-header");
    const navBarHeight = mobileNavBar ? mobileNavBar.offsetHeight : 0;

    if (mobileNavBar) {
      // Detect scroll direction
      if (st > lastScrollTop) {
        // Scroll Down - Hide navbar
        mobileNavBar.style.top = `-${navBarHeight}px`;
      } else {
        // Scroll Up - Show navbar
        mobileNavBar.style.top = "0";
      }
    }
    lastScrollTop = st;

    // Clear the timeout to detect stop scrolling
    window.clearTimeout(isScrolling);

    // Set a timeout to detect scrolling has stopped
    isScrolling = setTimeout(function () {
      if (mobileNavBar) {
        mobileNavBar.style.top = "0"; // Fix navbar when scrolling stops
      }
    }, 250);
  });
})

if (!customElements.get("component-review-slider")) {
  customElements.define(
    "component-review-slider",
    class ComponentReviewSlider extends HTMLElement {
      constructor() {
        super()
        this.sectionID = this.getAttribute("data-section-id")
        this.splide = this.querySelector(".splide")
        this.mountCarousel()
        if (Shopify.designMode) {
          document.addEventListener("shopify:section:load", (e) => {
            let eventSectionId = e.detail.sectionId
            if (this.sectionID == eventSectionId && this.splide) {
              this.carousel = new Splide(this.splide, {
                type: "loop",
                arrows: true,
                perPage: 1,
                pagination: false
              })
              this.carousel.mount()
            }
          })
          document.addEventListener("shopify:block:select", (e) => {
            // If splide exists and carousel is initialized
            if (this.carousel && this.splide && this.sectionID == e.detail.sectionId) {
              let block = document.querySelector(`[data-block-id="${e.detail.blockId}"][data-slide-index]`)
              // if the block exists with the index, navigate to the selected index.
              block ? this.carousel.go(parseInt(e.target.dataset.slideIndex)) : null
            }
          })
        }
      }
      mountCarousel() {
        // Only initialize Splide if the element exists
        if (this.splide) {
          this.carousel = new Splide(this.splide, {
            type: "loop",
            arrows: true,
            perPage: 1,
            pagination: false
          })
          this.carousel.mount()
        }
      }
    }
  )
}

if (!customElements.get("mobile-nav")) {
  customElements.define(
    "mobile-nav",
    class MobileNav extends HTMLElement {
      constructor() {
        super()
        this.focusableElements = this.querySelectorAll('a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])')
        this.mobileHeader = document.querySelector(".mobile-header")
        this.mobileHeaderHeight = this.mobileHeader.offsetHeight
        this.root = document.querySelector(":root")
        this.root.style.setProperty("--mobileHeaderHeight", `${this.mobileHeaderHeight}px`)
        this.init()
        if (Shopify.designMode) {
        }
      }
      init() {
        this.removeTabIndex()
        document.addEventListener("resize", this.checkHeaderHeight.bind(this))
        document.addEventListener("menu:toggled", this.setTabIndex.bind(this))
      }
      checkHeaderHeight() {
        let updatedMobileHeaderHeight = document.querySelector(".mobile-header").offsetHeight
        if (updatedMobileHeaderHeight != this.mobileHeaderHeight) {
          this.mobileHeaderHeight = updatedMobileHeaderHeight
          this.root.style.setProperty("--mobileHeaderHeight", `${this.mobileHeaderHeight}px`)
        }
      }
      setTabIndex() {
        let html = document.querySelector("html")
        let menuOpened = html.classList.contains("show-nav")
        !menuOpened ? this.removeTabIndex() : this.addTabIndex()
      }
      removeTabIndex() {
        this.focusableElements.forEach((element) => {
          element.setAttribute("tabindex", "-1")
          element.setAttribute("aria-hidden", "true")
        })
      }
      addTabIndex() {
        this.focusableElements.forEach((element) => {
          element.setAttribute("tabindex", "0")
          element.setAttribute("aria-hidden", "false")
        })
      }
    }
  )
}

const trapFocusHandlers = {}

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container)
  var first = elements[0]
  var last = elements[elements.length - 1]

  removeTrapFocus()

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return

    document.addEventListener("keydown", trapFocusHandlers.keydown)
  }

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown)
  }

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault()
      first.focus()
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault()
      last.focus()
    }
  }

  document.addEventListener("focusout", trapFocusHandlers.focusout)
  document.addEventListener("focusin", trapFocusHandlers.focusin)

  elementToFocus.focus()

  if (elementToFocus.tagName === "INPUT" && ["search", "text", "email", "url"].includes(elementToFocus.type) && elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length)
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin)
  document.removeEventListener("focusout", trapFocusHandlers.focusout)
  document.removeEventListener("keydown", trapFocusHandlers.keydown)

  if (elementToFocus) elementToFocus.focus()
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  )
}

if (!customElements.get("site-search")) {
  customElements.define(
    "site-search",
    class SiteSearch extends HTMLElement {
      constructor() {
        super()
        this.focusableElements = this.querySelectorAll('a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])')
        this.init()
        if (Shopify.designMode) {
        }
      }
      init() {
        this.removeTabIndex()
        document.addEventListener("search:toggled", this.setTabIndex.bind(this))
      }
      setTabIndex() {
        let menuOpened = document.querySelector(".open-search")
        !menuOpened ? this.removeTabIndex() : this.addTabIndex()
      }
      removeTabIndex() {
        this.focusableElements.forEach((element) => {
          element.setAttribute("tabindex", "-1")
          element.setAttribute("aria-hidden", "true")
        })
      }
      addTabIndex() {
        this.focusableElements.forEach((element) => {
          element.setAttribute("tabindex", "0")
          element.setAttribute("aria-hidden", "false")
        })
      }
    }
  )
}

if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      constructor() {
        super()
        this.button = this.querySelector('button')
        this.atcButton = document.querySelector('.btn--add-to-cart:not(.sticky-btn)')
        this.headerHeight = null
        this.init()
      }
      init() {
        this.button ? this.button.addEventListener('click', this.clickATCButton.bind(this)) : null
        this.setHeaderHeight()
        document.addEventListener('scroll', this.checkToActivateSticky.bind(this));
        window.addEventListener('resize', this.setHeaderHeight.bind(this));
      }
      setHeaderHeight() {
        if(document.querySelector('#shopify-section-header')?.offsetHeight != this.headerHeight){
          this.headerHeight = document.querySelector('#shopify-section-header') ? document.querySelector('#shopify-section-header').offsetHeight : null
          const root = document.documentElement;
          root.style.setProperty('--header-height', this.headerHeight + "px");
        }
      }
      checkToActivateSticky(e){
        let buttonBottom = this.atcButton.getBoundingClientRect().bottom
        let buttonHeight = this.atcButton.getBoundingClientRect().height
        if(buttonBottom <= 0 && buttonHeight != 0){
          !this.classList.contains('active') ? this.classList.add('active') : null
        }else {
          this.classList.contains('active') ? this.classList.remove('active') : null
        }
      }
      clickATCButton(e) {
        this.atcButton ? this.atcButton.click() : null
      }
    }
  )
}